import React from "react";

/**
 * Two overlapping native <input type="range"> elements sharing one track.
 * Each input's own track is made transparent via CSS (see index.css
 * .range-slider-input rules); only the thumb is interactive
 * (pointer-events: auto on ::-webkit-slider-thumb / ::-moz-range-thumb),
 * so dragging always grabs whichever handle you touch instead of the
 * two inputs fighting over clicks.
 */
export default function RangeSlider({ min, max, step = 1, value, onChange, formatLabel }) {
  const [lo, hi] = value;
  const pct = (v) => ((v - min) / (max - min)) * 100;

  const handleLoChange = (e) => {
    const v = Math.min(Number(e.target.value), hi - step);
    onChange([v, hi]);
  };
  const handleHiChange = (e) => {
    const v = Math.max(Number(e.target.value), lo + step);
    onChange([lo, v]);
  };

  const label = (v) => (formatLabel ? formatLabel(v) : v);

  return (
    <div>
      <div className="flex items-center justify-between text-xs font-semibold text-slate-800 mb-2">
        <span>{label(lo)}</span>
        <span>{label(hi)}</span>
      </div>
      <div className="relative h-5 flex items-center">
        {/* gray base track */}
        <div className="absolute left-0 right-0 h-1.5 rounded-full bg-slate-200" />
        {/* black fill between the two handles */}
        <div
          className="absolute h-1.5 rounded-full bg-black"
          style={{ left: `${pct(lo)}%`, right: `${100 - pct(hi)}%` }}
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={lo}
          onChange={handleLoChange}
          className="range-slider-input absolute w-full appearance-none bg-transparent"
          aria-label="Minimum"
        />
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={hi}
          onChange={handleHiChange}
          className="range-slider-input absolute w-full appearance-none bg-transparent"
          aria-label="Maximum"
        />
      </div>
    </div>
  );
}
